/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { ErrorResponse, Language } from "./data-contracts";
import { HttpClient, RequestParams } from "./http-client";

export class I18NExport<
  SecurityDataType = unknown,
> extends HttpClient<SecurityDataType> {
  /**
   * @description Downloads all currently valid i18n entries for the given language as an XLSX workbook
   *
   * @tags I18n Export
   * @name ExportLanguage
   * @summary Export language file
   * @request GET:/api/admin/i18n/{language}/export
   * @secure
   */
  exportLanguage = (language: Language, params: RequestParams = {}) =>
    this.request<string, ErrorResponse>({
      path: `/api/admin/i18n/${language}/export`,
      method: "GET",
      secure: true,
      ...params,
    });
}
